//import { ISideNav, ISubMenu, IPageTitle } from '../model';
import { IPageTitle } from '../../models/layout/page-title';
//import { _ } from '../utils'
import { ApiService } from '../../services/data/api.service';
import { Injectable } from '@angular/core';
interface ILayoutFactory {
    error: any;
    hasError: boolean;
    //menus: ISideNav[];
    //getMenuItems(): Promise<ISideNav[]>;
    //setSelectedMenu(parentId: number, childId: number): void;
    pageTitle: IPageTitle;
    setTitle(pageTitle: IPageTitle): void;
}

@Injectable()
export class LayoutFactory implements ILayoutFactory {
    public error: any;
    public hasError: boolean;
    //public menus: ISideNav[] = new Array<ISideNav>();
    //public selectedMenu: ISubMenu;

    public pageTitle: IPageTitle;
    public selectedScreen: string;
    constructor(public apiClient: ApiService) {
    }

/*    public getMenuItems(): ng.IPromise<ISideNav[]> {
        var deferred: ng.IDeferred<{}> = this.q.defer();
        deferred.resolve((this.createSideNav()) as ISideNav[]);
        return deferred.promise;
    }

    private createSideNav(): ISideNav[] {
        this.menus.push(
            { id: 1, order: 1, icon: '', isSelected: false, label: 'Favourites', url: '', subMenus: this.favouritesMenu() },
            { id: 2, order: 2, icon: '', isSelected: false, label: 'Members', url: '', subMenus: this.membersMenu() },
            { id: 3, order: 3, icon: '', isSelected: false, label: 'Non-Members', url: '', subMenus: this.nonmembersMenu() },
            { id: 4, order: 4, icon: '', isSelected: false, label: 'Training Mngt.', url: '', subMenus: this.sessionMenus() },
            { id: 5, order: 5, icon: '', isSelected: false, label: 'Training Admin', url: '', subMenus: this.providerMenus() },
            { id: 6, order: 6, icon: '', isSelected: false, label: 'Operational', url: '', subMenus: this.operationalMenus() },
            { id: 7, order: 7, icon: '', isSelected: false, label: 'Reports', url: '', subMenus: this.reportMenus() },
            { id: 8, order: 8, icon: '', isSelected: false, label: 'Organisation', url: '', subMenus: this.organisationDetailsMenus() },
            { id: 9, order: 9, icon: '', isSelected: false, label: 'Administration', url: '', subMenus: this.administrationMenuItems() }
        );
        return this.menus;
    }

    private favouritesMenu(): ISubMenu[] {
        let menus = Array<ISubMenu>();
        menus.push({ id: 1, order: 1, label: 'Member', src: 'Images/Details_PersonalRecord.png', url: 'members.member.details', params: { memberId: 'View' }, paramName: 'memberId' });
        menus.push({ id: 2, order: 2, label: 'Member Statistics', src: 'Images/filter_data_48.png', url: 'statistics.criteria.member', params: { configId: -1 } }); // , paramName: 'configId'
        menus.push({ id: 3, order: 3, label: 'Training Sessions', src: 'Images/Details_TrainingSignOffs.png', url: 'session.tabs.details', params: { sessionId: 'Add' }, paramName: 'sessionId' });
        menus.push({ id: 4, order: 4, label: 'Reports', src: 'Images/Details_Reports.png', url: 'members.member.reports', params: null });
        return menus;
    }

    private membersMenu(): ISubMenu[] {
        let menus = Array<ISubMenu>();
        menus.push({ id: 1, order: 1, label: 'Member', src: 'Images/Details_PersonalRecord.png', url: 'members.member.details', params: { memberId: 'Add' } });
        menus.push({ id: 2, order: 2, label: 'Member Statistics', src: 'Images/filter_data_48.png', url: 'statistics.criteria.member', params: { configId: -1 } });
        menus.push({ id: 3, order: 3, label: 'Member Groups', src: 'Images/group_48.png', url: '', params: null });
        menus.push({ id: 4, order: 4, label: 'Awards', src: 'Images/diplom2_48.png', url: '', params: null });
        return menus;
    }

    private nonmembersMenu(): ISubMenu[] {
        let menus = Array<ISubMenu>();
        menus.push({ id: 1, order: 1, label: 'Non-Members', src: 'Images/Details_PersonalRecord.png', url: '', params: null });
        menus.push({ id: 2, order: 2, label: 'Non-Member Statistics', src: 'Images/filter_data_48.png', url: '', params: null });
        return menus;
    }

    private administrationMenuItems(): ISubMenu[] {
        let menus = Array<ISubMenu>();
        menus.push({ id: 1, order: 1, label: 'Security', src: 'Images/user_lock_48.png', url: 'admin', params: null });
        menus.push({ id: 2, order: 2, label: 'Audit Trail', src: 'Images/book_zoom_48.png', url: 'audit', params: null });
        menus.push({ id: 3, order: 3, label: 'Security Audit', src: 'Images/security_test_zoom_48.png', url: '', params: null });
        menus.push({ id: 4, order: 4, label: 'Code Tables', src: 'Images/tool_config_48', url: '', params: null });
        menus.push({ id: 5, order: 5, label: 'AVETMISS / USI Mngt.', src: 'Images/contact_list_48', url: '', params: null });
        menus.push({ id: 6, order: 6, label: 'Options', src: 'Images/contract_write_48', url: '', params: null });
        return menus;
    }

    private sessionMenus(): ISubMenu[] {
        let menus = Array<ISubMenu>();
        menus.push({ id: 1, order: 1, label: 'Training Sessions', src: 'Images/classmate_write_48.png', url: 'session.tabs.details', params: { sessionId: 'Add' } });
        menus.push({ id: 2, order: 2, label: 'Session Planner', src: 'Images/schedule_48.png', url: '', params: null });
        menus.push({ id: 3, order: 3, label: 'Competency Planning', src: 'Images/filter_data_clock_48.png', url: '', params: null });
        menus.push({ id: 4, order: 4, label: 'Training Progress', src: 'Images/scientific_cal_48.png', url: '', params: null });
        menus.push({ id: 5, order: 5, label: 'Member Training Summary', src: 'Images/fila_search_48.png', url: '', params: null });
        menus.push({ id: 6, order: 6, label: 'Training Hours', src: 'Images/clock_in_clock_48.png', url: '', params: null });
        menus.push({ id: 7, order: 7, label: 'Automatic Completions', src: 'Images/confirmation_write_48.png', url: '', params: null });
        menus.push({ id: 8, order: 8, label: 'AVETMISS Data Export', src: 'Images/filter_data_save_48.png', url: '', params: null });
        return menus;
    }

    private reportMenus(): ISubMenu[] {
        let menus = Array<ISubMenu>();
        menus.push({ id: 1, order: 1, label: 'Reports', src: 'Images/Details_Reports.png', url: 'members.member.reports', params: null });
        menus.push({ id: 2, order: 2, label: 'Member Statistics', src: 'Images/filter_data_48.png', url: 'statistics.criteria.member', params: { configId: -1 } });
        menus.push({ id: 3, order: 3, label: 'Non-Member Statistics', src: 'Images/filter_data_48.png', url: '', params: null });
        menus.push({ id: 4, order: 4, label: 'Provider Statistics', src: 'Images/filter_data_48.png', url: '', params: null });
        return menus;
    }

    private providerMenus(): ISubMenu[] {
        let menus = Array<ISubMenu>();
        menus.push({ id: 1, order: 1, label: 'Providers', src: 'Images/meeting_48.png', url: 'provider.tabs.details', params: { providerId: 'Add' } });
        menus.push({ id: 2, order: 2, label: 'Role Requirements', src: 'Images/high_school_write_48.png', url: 'role.requirements.details', params: { roleId: 'Add' } });
        menus.push({ id: 3, order: 3, label: 'Training', src: 'Images/homework_48.png', url: 'training.tabs.details', params: { id: 'View' }, paramName: 'id' });
        menus.push({ id: 4, order: 4, label: 'Training Role Supervisors', src: 'Images/high_school_zoom_48.png', url: '', params: null });
        menus.push({ id: 5, order: 5, label: 'Venues', src: 'Images/high_school_write_48.png', url: '', params: null });
        menus.push({ id: 6, order: 6, label: 'Provider Statistics', src: 'Images/filter_data_48.png', url: '', params: null });

        return menus;
    }

    private operationalMenus(): ISubMenu[] {
        let menus = Array<ISubMenu>();
        menus.push({ id: 1, order: 1, label: 'Incidents', src: 'Images/fire_engine_48.png', url: '', params: null });
        menus.push({ id: 2, order: 2, label: 'Incident Configuration', src: 'Images/fire_engine_info_48.png', url: '', params: null });
        return menus;
    }

    private organisationDetailsMenus(): ISubMenu[] {
        let menus = Array<ISubMenu>();
        menus.push({ id: 1, order: 1, label: 'Organisation Details', src: 'Images/company_48.png', url: 'organisation.tabs.details', params: { Id: 'Add' } });
        menus.push({ id: 2, order: 2, label: 'Organisational Model', src: 'Images/organigram_48.png', url: '', params: null });
        menus.push({ id: 3, order: 3, label: 'Organisation Configuration', src: 'Images/company_info_48.png', url: '', params: null });
        menus.push({ id: 4, order: 4, label: 'SFEC Requirements', src: 'Images/record2_config_48.png', url: '', params: null });
        menus.push({ id: 5, order: 5, label: 'Elections', src: 'Images/mail-box_write_48.png', url: '', params: null });
        return menus;
    }

    public setSelectedMenu(parentId: number, childId: number): void {
        this.selectedMenu = _.find(_.find(this.menus, { 'id': parentId }).subMenus, { 'id': childId });
    }*/
    public setTitle(pageTitle: IPageTitle): void {
        this.pageTitle = pageTitle;
    }
}